import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from "prop-types";
import { Table, Badge, Button, Modal } from 'react-bootstrap';
import AddItems from './PopUps/Add/AddItems';
import EditItems from './PopUps/Edit/EditItems';
import * as Icon from 'react-feather';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import { canPageAction } from '../../config/roleConfig';
import DeactivateConfirmModal from '../Common/DeactivateConfirmModal';

function NewUnits(props) {
    const [data, setData] = useState([]);
    const [expandedUnit, setExpandedUnit] = useState(null);
    const [unitToDeactivate, setUnitToDeactivate] = useState(null);
    const [deactivatingUnit, setDeactivatingUnit] = useState(false);
    const apiUrl = process.env.REACT_APP_URL;
    const authHeader = useAuthHeader();
    const authUser = useAuthUser();
    const currentUser = authUser();
    const canRead = canPageAction(currentUser, 'operations.fleet', 'read');
    const canWrite = canPageAction(currentUser, 'operations.fleet', 'write');
    const canDelete = canPageAction(currentUser, 'operations.fleet', 'delete');

    const roleVariant = (role) => {
        if (role === 'trailer') return 'info';
        if (role === 'power_unit') return 'primary';
        if (role === 'straight_truck') return 'secondary';
        return 'light';
    };

    const get_all_data = () => {
        axios({
            method:'GET',
            url:apiUrl+'/units/get_all_units',
            headers: {
                Authorization: authHeader()
            }
        }).then(response => {
            setData(response.data.msg.Units);
        })
        .catch(error => {
            alert(error);
        });
    }

    useEffect(() => {
        get_all_data();
    }, []);

    const toggleUnitDetails = (unitId) => {
        setExpandedUnit(expandedUnit === unitId ? null : unitId);
    };

    const deleteUnit = (unit) => {
        if (!unit) {
            return;
        }

        setDeactivatingUnit(true);
        axios({
            method: 'DELETE',
            url: apiUrl + '/units/delete',
            headers: {
                Authorization: authHeader()
            },
            data: { id: unit.id }
        }).then(() => {
            setUnitToDeactivate(null);
            get_all_data();
        }).catch(error => {
            alert(error.response?.data?.error || 'No se pudo desactivar la unidad');
            console.log(error);
        }).finally(() => {
            setDeactivatingUnit(false);
        });
    };

        return (
            <>
            <div className="card mb-4">
                <div className="card-body">
                    <div className="card-header d-flex justify-content-between">
                        <h5 className="card-title">Unidades</h5>
                        {canWrite && <AddItems setData={get_all_data}/>}
                    </div>

                    <div className="height-310">
                        <Table className="m-0" responsive>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Tipo</th>
                                    <th>Equipo</th>
                                    <th>Marca y Modelo</th>
                                    <th>Ejes</th>
                                    <th>Año</th>
                                    <th>Placas</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map(unit => (
                                    <React.Fragment key={unit.id}>
                                        <tr>
                                            <td>{unit.name}</td>
                                            <td>{unit.inventory_type}</td>
                                            <td>
                                                <div className="d-flex flex-column gap-1 align-items-start">
                                                    <Badge bg={roleVariant(unit.equipment_role)}>
                                                        {unit.equipment_role_label || 'Sin clasificar'}
                                                    </Badge>
                                                    {unit.requires_trailer && (
                                                        <Badge bg="warning" text="dark">
                                                            Requiere remolque
                                                        </Badge>
                                                    )}
                                                </div>
                                            </td>
                                            <td>{unit.make} {unit.model}</td>
                                            <td>{unit.axles}</td>
                                            <td>{unit.year}</td>
                                            <td>{unit.plates}</td>
                                            <td>
                                                <div className="d-flex gap-1">
                                                    {canRead && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-primary"
                                                            onClick={() => toggleUnitDetails(unit.id)}
                                                        >
                                                            <Icon.Eye size={14} />
                                                        </Button>
                                                    )}
                                                    {canWrite && <EditItems setData={get_all_data} unitInfo={unit}/>}
                                                    {canDelete && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-danger"
                                                            onClick={() => setUnitToDeactivate(unit)}
                                                        >
                                                            <Icon.Trash2 size={14} />
                                                        </Button>
                                                    )}
                                                    {!canRead && !canWrite && !canDelete && (
                                                        <span className="text-muted">N/A</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        {expandedUnit === unit.id && (
                                            <tr>
                                                <td colSpan={8}>
                                                    <div className="p-3 bg-light">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <p><strong>Dimensiones:</strong> {unit.length || 0} x {unit.width || 0} x {unit.height || 0}</p>
                                                                <p><strong>Metros:</strong> {unit.meters || 'N/A'}</p>
                                                                <p><strong>Equipo:</strong> {unit.equipment_role_label || 'N/A'}</p>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <p><strong>Config. Vehicular:</strong> {unit.config_vehicular || 'N/A'}</p>
                                                                <p><strong>Peso Bruto:</strong> {unit.peso_bruto_vehicular || 'N/A'}</p>
                                                                <p><strong>Subtipo Remolque:</strong> {unit.subtipo_rem || 'N/A'}</p>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <p><strong>Permiso SCT:</strong> {unit.permiso_sct || 'N/A'}</p>
                                                                <p><strong>No. Permiso SCT:</strong> {unit.num_permiso_sct || 'N/A'}</p>
                                                                <p><strong>Requiere Remolque:</strong> {unit.requires_trailer ? 'Si' : 'No'}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
            <DeactivateConfirmModal
                show={Boolean(unitToDeactivate)}
                title="Desactivar Unidad"
                itemLabel={unitToDeactivate?.name}
                confirming={deactivatingUnit}
                onCancel={() => !deactivatingUnit && setUnitToDeactivate(null)}
                onConfirm={() => deleteUnit(unitToDeactivate)}
            />
            </>
        );
}

//Status: Entregado, Pendiente, Cancelado, En camino
// Success, Warning, Danger, Info
//https://react-bootstrap.netlify.app/docs/components/badge/


export default NewUnits;
